export default "__VITE_ASSET__DPm6p2ls__"